var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"home-slogan"},[_c('p',{staticClass:"shadow-shake-text"},[_vm._v("$100M Ads Purchase Achieved！")])])
}]

export { render, staticRenderFns }